/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModuleSecondaryOld_homepage = {
    readonly promoSecondaryModule: {
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly imageUrl?: string | null;
            readonly imageCopy: string | null;
            readonly cta: string | null;
            readonly mobileImageUrl?: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly promoPrimaryModule: {
        readonly totalItemsCount?: number | null;
    } | null;
    readonly " $refType": "HpRespPromoModuleSecondaryOld_homepage";
};
export type HpRespPromoModuleSecondaryOld_homepage$data = HpRespPromoModuleSecondaryOld_homepage;
export type HpRespPromoModuleSecondaryOld_homepage$key = {
    readonly " $data"?: HpRespPromoModuleSecondaryOld_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModuleSecondaryOld_homepage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModuleSecondaryOld_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "promoSecondaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoSecondary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoSecondary"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "PromoItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageCopy",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cta",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "imageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isMobile",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mobileImageUrl",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "promoPrimaryModule",
      "name": "module",
      "storageKey": "module(type:\"promoPrimary\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "promoPrimary"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PromoModule",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalItemsCount",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '807be1a1fba68ab88b056922343d8ce4';
export default node;
